import React from 'react';
import PartnerDetailPage from '../domains/partners/components/PartnerDetailPage';

const AdminPartnerDetail: React.FC = () => <PartnerDetailPage />;

export default AdminPartnerDetail;
